export default "__VITE_ASSET__DiqfYYAK__"